import React from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import { DataReportedBy } from '../../DataReportedBy'
import AgentInformation from './components/AgentInformation'
import InsuranceTabs from './components/InsuranceTabs'

const useStyles = makeStyles({
  // Targeting the tab icon to align it with the text
  noPadding: {
    '& .ph5.pv4': {
      display: 'flex',
      justifyContent: 'space-center',
      alignItems: 'center',
      '& .tab-icon': {
        top: 0,
        display: 'grid',
        placeItems: 'center',
      },
    },
  },
  maxWidth: {
    width: '100%',
    maxWidth: '100%',
  },
})

export const Insurance = () => {
  const classes = useStyles()

  return (
    <Card className={classes.maxWidth}>
      <Box
        display='flex'
        flexDirection='column'
        gap='24px'
        className={classes.noPadding}
        width='100%'
        boxSizing='border-box'>
        <Typography variant='h3'>Insurance</Typography>
        <AgentInformation />
        <Box display='grid' maxWidth='100%'>
          <Typography variant='subtitle1'>Policies</Typography>
          <DataReportedBy reporter='highway' />
          <InsuranceTabs />
        </Box>
      </Box>
    </Card>
  )
}
